/**
 * Base URL for app API (user area). Used for WorkOS auth config/initiate/callback
 * which are under app/{client}, not app/{client}/admin.
 */
const MIX_API_ENDPOINT_BASE = process.env.MIX_API_ENDPOINT_BASE || '';

export const getAppAPIBase = clientId => {
    return `${MIX_API_ENDPOINT_BASE}/app/${clientId}`;
};

export const getAdminAPIBase = clientId => {
    return `${MIX_API_ENDPOINT_BASE}/app/${clientId}/admin`;
};

export default getAppAPIBase;
